import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IntakeComponent } from './intake/intake.component';
import { AllergyComponent } from './allergy/allergy.component';
import { MedicationComponent } from './medication/medication.component';
import { FamilyHistoryComponent } from './family-history/family-history.component';
import { SocialHistoryComponent } from './social-history/social-history.component';
import { PostHospitalizationComponent } from './post-hospitalization/post-hospitalization.component';
import { PastSurgicalHistoryComponent } from './past-surgical-history/past-surgical-history.component';

const routes: Routes = [
  {
    path: '',
    component: IntakeComponent,
    children :[
      {
        path: 'allergy',
        component: AllergyComponent
      },
      {
        path: 'medication',
        component: MedicationComponent
      },
      {
        path: 'family-history',
        component: FamilyHistoryComponent
      },
      {
        path: 'social-history',
        component: SocialHistoryComponent
      },
      {
        path: 'past-surgical-history',
        component: PastSurgicalHistoryComponent
      },
      {
        path: 'past-hospitalization-history',
        component: PostHospitalizationComponent
      }
    ]
  },
  // {
  //   path: 'intake',
  //   component: IntakeComponent,
  //   children :[
  //     {
  //       path: 'allergy',
  //       component: AllergyComponent
  //     },
  //     {
  //       path: 'medications',
  //       component: MedicationComponent
  //     },
  //     {
  //       path: 'medical-history',
  //       component: MedicalHistoryComponent
  //     },
  //     {
  //       path: 'family-history',
  //       component: FamilyHistoryComponent
  //     },
  //     {
  //       path: 'social-history',
  //       component: SocialHistoryComponent
  //     }
  //   ]
  // }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IntakemoduleRoutingModule { }